
export const CARD_CONFIG: ICardConfig = {
  number: {
    control: 'number',
    placeholder: '4242 XXXX XXXX XXXX',
    mask: '0000 0000 0000 0000',
    prefix: '',
    classname: 'card-number',
    label: 'Card number',
    show: true,
    type: 'tel',
    dropSpecialCharacters: true
  },
  expiry: {
    control: 'expiry',
    placeholder: 'MM / YY',
    mask: '00/00',
    prefix: '',
    classname: 'card-expiry',
    label: 'Expiry date',
    show: true,
    type: 'tel',
    dropSpecialCharacters: false
  },
  cvv: {
    control: 'cvv',
    placeholder: 'CVV / CVC',
    mask: '000',
    prefix: '',
    classname: 'card-cvv',
    label: 'CVV',
    show: true,
    type: 'password',
    dropSpecialCharacters: true
  },
  pincode: {
    control: 'pincode',
    mask: '',
    prefix: '',
    classname: 'pincode',
    label: 'Zipcode',
    show: false,
    type: 'tel',
    dropSpecialCharacters: true
  },
  name: {
    control: 'name',
    mask: '',
    prefix: '',
    classname: 'name-on-card',
    label: 'Name on card',
    show: true,
    type: 'text'
  },
  keys: ['number', 'expiry', 'cvv', 'pincode', 'name']
};

export interface ICardConfig {
  number: ICardInputConfig;
  pincode: ICardInputConfig;
  cvv: ICardInputConfig;
  expiry: ICardInputConfig;
  name: ICardInputConfig;
  keys: string[];
}

export interface ICardInputConfig {
  control?: string;
  placeholder?: string;
  type?: string;
  prefix?: string;
  mask?: string;
  classname: string;
  label: string;
  show: boolean;
  error?: string;
  dropSpecialCharacters?: boolean;
}
